var map = {
	"./screen1.png": 231,
	"./screen2.png": 232,
	"./screen3.png": 233,
	"./screen4.png": 234,
	"./screen5.png": 235,
	"./screen6.png": 236,
	"./screen7.png": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;